// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__32qWX","title":"AfterImages90_title__3I251","images":"AfterImages90_images__2N_AF"};